import React from 'react';

interface DropdownHeaderProps {
  isOpen: boolean;
  title: string;
}

export default class DropdownHeader extends React.PureComponent<DropdownHeaderProps> {
  render() {
    return (
      <p className="dropdown-header">
        {this.props.title}
        <span className={`gik-icon-v2 icon-v2-chevronDown`}></span>
      </p>
    );
  }
}
